import React from 'react';
import NavTab from '@components/navigation-bar/components/NavTab';
import PermissionFlag from '@src/emp-3.0/components/PermissionButton/PermissionFlag';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import Workbench from '@src/emp-3.0/components/WorkbenchButton/WorkbenchButton';

const NavigationBar = () => {
  const { userInfo } = useInitialInfoStore();
  const enableVisualActivation = userInfo?.mobile_visual_activation;
  const { workbenchMode } = useInitialInfoStore();
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ marginLeft: '1px' }}>
        <NavTab to={`/home`}>Home</NavTab>
        <NavTab to={`/semantic-mapper`}>Semantic Mapper</NavTab>
        <NavTab to={`/metric-builder`}>Metric Builder</NavTab>
        <NavTab to={`/management`}>Management</NavTab>
        {!workbenchMode && (
          <NavTab to={`/sensor-remote-control`} data-test-id="sensorRemoteConfigTab">
            Sensor Remote Control
          </NavTab>
        )}
        {!workbenchMode && <NavTab to={`/livelens`}>LiveLens</NavTab>}

        {enableVisualActivation && !workbenchMode && (
          <NavTab to={`/visual-activation`}>Visual Activation</NavTab>
        )}
      </div>
      <div style={{ display: 'flex', gap: '3px' }}>
        <Workbench />
        <PermissionFlag />
      </div>
    </div>
  );
};

export default NavigationBar;
